import { parseBooleanValue } from "../../util";
import { IDocumentType } from "../model/DocumentType";
import VisibilityLevelParamMapper from "./VisibilityLevelParamMapper";

const DocumentTypeParamMapper = (item: IDocumentType) => {
  return item.visibilityLevels && item.visibilityLevels.length > 0
    ? {
        ...item,
        valid: parseBooleanValue(item.valid),
        visibilityLevels: item.visibilityLevels?.map((elem) =>
          VisibilityLevelParamMapper(elem)
        )
      }
    : {
        ...item,
        valid: parseBooleanValue(item.valid)
      };
};

export default DocumentTypeParamMapper;
